import { useEffect, useState } from "react";
import { CheckCircle2, AlertTriangle, Crop } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CropDialog } from "@/components/CropDialog";

const SCREEN = 16 / 9;
const isScreenFormat = (w, h) => Math.abs(w / h - SCREEN) / SCREEN <= 0.05;

const FilePreview = ({ file, idx, onReplace }) => {
  const [cropping, setCropping] = useState(false);
  const [url, setUrl] = useState("");
  const [size, setSize] = useState(null);
  useEffect(() => {
    const u = URL.createObjectURL(file);
    setUrl(u);
    return () => URL.revokeObjectURL(u);
  }, [file]);
  const ok = size && isScreenFormat(size.w, size.h);

  return (
    <div className="space-y-1" data-testid={`format-preview-${idx}`}>
      <div className="relative aspect-video overflow-hidden rounded-md bg-black">
        {url && (
          <>
            <img src={url} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full scale-110 object-cover opacity-60 blur-xl" />
            <img src={url} alt={file.name} className="absolute inset-0 h-full w-full object-contain"
              onLoad={(e) => setSize({ w: e.currentTarget.naturalWidth, h: e.currentTarget.naturalHeight })} />
          </>
        )}
      </div>
      {size && (
        <p className={`flex items-center gap-1 text-[11px] ${ok ? "text-emerald-500" : "text-amber-500"}`} data-testid={`format-status-${idx}`}>
          {ok ? <CheckCircle2 className="h-3 w-3 shrink-0" /> : <AlertTriangle className="h-3 w-3 shrink-0" />}
          <span>{ok ? "Format écran" : `Pas au format écran (${size.w}×${size.h}) : bords flous`}</span>
        </p>
      )}
      {size && !ok && (
        <Button type="button" size="sm" variant="secondary" className="h-7 w-full text-xs" onClick={() => setCropping(true)} data-testid={`crop-button-${idx}`}>
          <Crop className="mr-1 h-3.5 w-3.5" /> Recadrer en 16/9
        </Button>
      )}
      {cropping && <CropDialog file={file} url={url} onClose={() => setCropping(false)} onCropped={(f) => onReplace(idx, f)} />}
    </div>
  );
};

export const FormatPreview = ({ files, onReplace }) => {
  const list = Array.from(files || []);
  if (!list.some((f) => f.type.startsWith("image/"))) return null;
  return (
    <div className="space-y-2" data-testid="format-preview-list">
      <p className="text-xs text-muted-foreground">Aperçu du rendu sur l'écran TV (16/9) :</p>
      <div className="grid max-h-72 grid-cols-2 gap-3 overflow-y-auto pr-1 sm:grid-cols-3">
        {list.map((f, i) => f.type.startsWith("image/") && <FilePreview key={`${f.name}-${f.size}-${i}`} file={f} idx={i} onReplace={onReplace} />)}
      </div>
    </div>
  );
};
